module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/DM-61ddc31c3e95aad1fbb2bcb7175b48d5.png";